import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable()
export class EmailService {
  private urlModulo = `${environment.urlAPI}/email`;

  constructor(private http: HttpClient) { }

  /**
   * Grava e envia o email
   * @param obj Dados do email a ser enviado
   */
  public enviaEmail(obj: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.post(`${this.urlModulo}`, obj)
        .subscribe({
          next: (response: any) => {
            if (response.type === true) {
              resolve(response.data);
            } else {
              console.error('Erro ao enviar email');
              reject(response.data);
            }
          },
          error: (error) => {
            console.error('Erro ao enviar email');
            reject(error);
          }
        });
    });
  }

  /**
   * Envia email de reset de senha
   * @param cpf_cnpj CPF/CNPJ do usuário
   * @param token Token de autenticação
   */
  public resetSenha(cpf_cnpj: string, token: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.post(`${this.urlModulo}-resetsenha`, { cpf_cnpj, token })
        .subscribe({
          next: (response: any) => {
            if (response.type === true) {
              resolve(response.data);
            } else {
              reject(response.data);
            }
          },
          error: (error) => {
            console.error('Erro ao enviar email de reset de senha:');
            reject(error);
          }
        });
    });
  }

  /**
   * Envia email para um destinatário específico
   * @param nome Nome do destinatário
   * @param email Email do destinatário
   * @param template Template a ser utilizado
   * @param params Parâmetros adicionais (opcional)
   */
  public async enviarEmail(nome: string, email: string, template: string, params?: string): Promise<void> {
    const payload = {
      paraEmail: email,
      paraNome: nome,
      template: template,
      ...params ? this.parseParams(params) : {}
    };

    try {
      await this.enviaEmail(payload);
    } catch (error) {
      console.error('Erro ao enviar email individual:');
    }
  }

  /**
   * Envia email para um grupo de destinatários
   * @param nomeGrupo Nome do grupo
   * @param id Identificador do grupo
   * @param template Template a ser utilizado
   * @param params Parâmetros adicionais (opcional)
   */
  public async enviarEmailGrupo(nomeGrupo: string, id: string | number, template: string, params?: string): Promise<void> {
    const payload = {
      nomeGrupo,
      id,
      template,
      ...params ? this.parseParams(params) : {}
    };

    try {
      await this.enviaEmail(payload);
    } catch (error) {
      console.error('Erro ao enviar email para grupo:');
    }
  }

  /**
   * Converte string de parâmetros em objeto
   * @param params String no formato "chave=valor&chave2=valor2"
   * @returns Objeto com os parâmetros
   */
  private parseParams(params: string): Record<string, string> {
    const result = {};
    params.split('&').forEach(param => {
      const [key, value] = param.split('=');
      if (key && value) {
        result[key] = value;
      }
    });
    return result;
  }
}


// WEBPACK FOOTER //
// /app/src/app/services/email.service.ts